import axios from 'axios'

import { LeadsValues } from '../LeadsPage.schema'

interface LeadsData extends LeadsValues {
  result: string
  territoryOwner: string
  technology: string
  address: string
  sfId: string
}

export default class LeadsService {
  constructor(private host: string) {}

  setSalesLead(data: LeadsData) {
    return axios({
      method: 'POST',
      url: `${this.host}/v1/leads/lead`,
      data,
      headers: {
        Authorization: 'Basic aXRtYXNtb3ZpbDo3NEFxckprWG1CZzFSNVNNL0xxWmJ0cGdXVXhaQld6S2tnMUl4NWIr',
      },
    }).then((res) => res.data)
  }
}
